<template>
  <main-template>
    <!-- PEI — Plano Educacional Individualizado (#7286Quatro seções numerada-->
    <v-row>
      <v-col>
        <div class="d-flex flex-wrap align-center justify-space-between pb-6">
          <div class="d-flex align-center">
            <v-btn id="btn-voltar-pei" color="primary" x-small text @click="$goBack()">
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            <div>
              <h1 class="text-h5 font-weight-bold mb-0">PEI — Plano Educacional Individualizado</h1>
            </div>
          </div>

          <div v-if="carregado" class="d-flex align-center">
            <v-btn
              id="btn-baixar-pei"
              color="primary"
              outlined
              class="mr-2"
              :disabled="!peiExistente"
              @click="baixar"
            >
              <v-icon left small>fa fa-file-pdf</v-icon>
              Baixar P.E.I
            </v-btn>
            <v-btn id="btn-salvar-pei" color="primary" :loading="salvando" @click="salvar">
              <v-icon left small>fa fa-save</v-icon>
              Salvar
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <template v-if="carregado">
      <!--
        Teto do quadro medido via JS (offsetTop real), não chutado em calc(100vh - N): o
        offset acima do quadro varia por rota (com/sem faixa de alerta, franquia etc.), e
        um valor fixo sobra ou falta espaço dependendo da telMedir direto no mounted
        pegava o layout do cabeçalho ainda assentando e calculava alto demais; por isso a
        medição roda em dois requestAnimationFrame (espera o layout pintar) e de novo no
        resizÉ max-height, não height: aba curta (Identificação) encolhe pro
        tamanho do conteúdo em vez de sobrar espaço em branco; aba longa trava no teto e
        só aí o conteúdo abaixo das abas rola por dentro (a barra de abas fica fixa).
      -->
      <div ref="peiQuadro" class="pei-quadro" :style="{ maxHeight: alturaMaximaQuadro }">
        <v-tabs
          id="tabs-secoes-pei"
          v-model="secaoAtiva"
          grow
          icons-and-text
          background-color="primary"
          dark
          class="rounded-t-lg flex-shrink-0"
        >
          <v-tab v-for="secao of secoes" :key="secao.valor" :id="`tab-secao-${secao.valor}`">
            {{ secao.titulo }}
            <v-icon>{{ secao.icone }}</v-icon>
          </v-tab>
        </v-tabs>

        <div ref="conteudoPei" class="pei-conteudo rounded-b-lg">
          <div v-show="secaoAtiva === 0">
            <div class="pa-4">
              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <div class="text-caption text--secondary">Professores(as) Regentes</div>
                      <div class="text-body-2 font-weight-medium">
                        {{ identificacao.professores_regentes.join(", ") || "- - -" }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="text-caption text--secondary">
                        Professor Auxiliar / Profissional de Apoio
                      </div>
                      <div class="text-body-2 font-weight-medium">
                        {{ identificacao.profissional_de_apoio || "- - -" }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="text-caption text--secondary">Aluno</div>
                      <div class="text-body-2 font-weight-medium">
                        {{ identificacao.aluno || "- - -" }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="text-caption text--secondary">Data</div>
                      <div class="text-body-2 font-weight-medium">{{ dataFormatada }}</div>
                    </v-col>
                    <v-col cols="12" md="3">
                      <div class="text-caption text--secondary">Bimestre</div>
                      <div class="text-body-2 font-weight-medium">
                        {{ bimestreDescricao }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="text-caption text--secondary">Turma</div>
                      <div class="text-body-2 font-weight-medium">
                        {{ identificacao.turma || "- - -" }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="text-caption text--secondary">Turno</div>
                      <div class="text-body-2 font-weight-medium">
                        {{ identificacao.turno || "- - -" }}
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="text-caption text--secondary mb-1">
                        Deficiência / TEA / Altas habilidades ou superdotação
                      </div>
                      <!-- Somente leitura: mostra o vínculo já cadastrado no aluno, sem
                           opção de marcar/desmarcar aqui — mesmo padrão de Disciplina-->
                      <v-chip
                        v-for="deficiencia of identificacao.deficiencias_do_cadastro"
                        :key="deficiencia"
                        color="primary"
                        outlined
                        class="mr-1 mb-1"
                      >
                        {{ deficiencia }}
                      </v-chip>
                      <div
                        v-if="!identificacao.deficiencias_do_cadastro.length"
                        class="text-body-2 text--secondary font-italic"
                      >
                        Nenhuma condição registrada no cadastro do aluno
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <!-- ===== ESTUDO DE CASO ===== -->
          <div v-show="secaoAtiva === 1">
            <div class="pa-4">
              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-1">
                    Mapeamento de Barreiras
                    <v-chip class="ml-1" x-small :color="corDoBadge(totalDeBarreiras)" dark>
                      {{ totalDeBarreiras }} marcada(s)
                    </v-chip>
                  </div>
                  <div class="text-caption text--secondary mb-2">
                    O que impede o acesso? Marque as barreiras identificadas no ambiente escolar.
                  </div>

                  <v-expansion-panels v-model="grupoDeBarreiraAtivo" class="barreiras-expansions">
                    <v-expansion-panel
                      v-for="(itens, grupo) of opcoes.mapeamento_barreiras"
                      :key="`panel-${grupo}`"
                      :id="`panel-barreira-${slug(grupo)}`"
                    >
                      <v-expansion-panel-header class="font-weight-medium">
                        <span class="text-truncate">{{ grupo }}</span>
                        <template v-slot:actions>
                          <v-chip
                            x-small
                            :color="corDoBadge(barreirasDoGrupo(grupo))"
                            dark
                            class="mr-2"
                          >
                            {{ barreirasDoGrupo(grupo) }}
                          </v-chip>
                          <v-icon>$expand</v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row dense>
                          <v-col
                            class="py-0"
                            cols="12"
                            sm="6"
                            md="4"
                            v-for="item of itens"
                            :key="item"
                          >
                            <v-checkbox
                              :id="`check-barreira-${slug(grupo)}-${slug(item)}`"
                              hide-details
                              dense
                              :input-value="barreiraMarcada(grupo, item)"
                              :label="item"
                              @change="(marcado) => alternarBarreira(grupo, item, marcado)"
                            />
                          </v-col>
                        </v-row>
                        <div v-if="isInfantil" class="text-subtitle-2 font-weight-bold mb-1 mt-4">
                          Observações para este grupo
                        </div>
                        <v-textarea
                          v-if="isInfantil"
                          :id="`input-observacoes-${slug(grupo)}`"
                          :value="form.mapeamento_barreiras_observacoes[grupo]"
                          rows="2"
                          outlined
                          dense
                          auto-grow
                          @input="definirObservacao(grupo, $event)"
                        />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-1">
                    Potencialidades e Interesses
                    <v-chip
                      class="ml-1"
                      x-small
                      :color="corDoBadge(form.potencialidades_interesses.length)"
                      dark
                    >
                      {{ form.potencialidades_interesses.length }} marcada(s)
                    </v-chip>
                  </div>
                  <div class="text-caption text--secondary mb-2">
                    Onde o aluno ancora a aprendizagem?
                  </div>
                  <v-row dense>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                      md="4"
                      v-for="opcao of opcoes.potencialidades_interesses"
                      :key="opcao"
                    >
                      <v-checkbox
                        :id="`check-potencialidade-${slug(opcao)}`"
                        hide-details
                        dense
                        v-model="form.potencialidades_interesses"
                        :label="opcao"
                        :value="opcao"
                      />
                    </v-col>
                  </v-row>
                  <v-text-field
                    id="input-interesse-especifico"
                    v-model="form.interesse_especifico"
                    label="Interesse específico"
                    outlined
                    dense
                    maxlength="250"
                    counter
                    class="mt-8"
                  />
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-2">Descrição da Demanda</div>
                  <v-textarea
                    id="input-descricao-demanda"
                    v-model="form.descricao_demanda"
                    rows="5"
                    outlined
                    auto-grow
                    maxlength="1000"
                    counter
                  />
                  <!-- Os três campos textuais que só o Infantil tem -->
                  <template v-if="isInfantil">
                    <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">
                      Como a criança aprende melhor
                    </div>
                    <v-textarea
                      id="input-como-aprende-melhor"
                      v-model="form.demanda_como_aprende_melhor"
                      rows="5"
                      outlined
                      auto-grow
                      maxlength="1000"
                      counter
                    />
                    <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">
                      Quais barreiras aparecem com maior frequência na rotina
                    </div>
                    <v-textarea
                      id="input-barreiras-frequentes"
                      v-model="form.demanda_barreiras_frequentes"
                      rows="5"
                      outlined
                      auto-grow
                      maxlength="1000"
                      counter
                    />
                    <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">
                      Quais estratégias pedagógicas já favoreceram a participação
                    </div>
                    <v-textarea
                      id="input-estrategias-que-favoreceram"
                      v-model="form.demanda_estrategias_que_favoreceram"
                      rows="5"
                      outlined
                      auto-grow
                      maxlength="1000"
                      counter
                    />
                  </template>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <!-- ===== PLANO DE SUPORTE E ACESSIBILIDADE ===== -->
          <div v-show="secaoAtiva === 2">
            <div class="pa-4">
              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-1">
                    Profissional de Apoio Escolar
                  </div>
                  <e-opcao-unica-cards
                    v-model="form.profissional_apoio_escolar"
                    :opcoes="opcoes.profissional_apoio_escolar"
                    prefixo-id="radio-apoio"
                  />
                  <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">Especificar momentos</div>
                  <v-textarea
                    id="input-apoio-momentos"
                    v-model="form.profissional_apoio_momentos"
                    rows="5"
                    outlined
                    auto-grow
                    class="mt-3"
                  />
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-2">Adaptação de Materiais</div>
                  <v-row dense>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                      md="4"
                      v-for="opcao of opcoes.adaptacao_materiais"
                      :key="opcao"
                    >
                      <v-checkbox
                        :id="`check-adaptacao-${slug(opcao)}`"
                        hide-details
                        dense
                        v-model="form.adaptacao_materiais"
                        :label="opcao"
                        :value="opcao"
                      />
                    </v-col>
                  </v-row>
                  <v-text-field
                    v-if="isInfantil"
                    id="input-adaptacao-outra"
                    v-model="form.adaptacao_materiais_outra"
                    label="Outra Tecnologia Assistiva"
                    outlined
                    dense
                    maxlength="250"
                    counter
                    class="mt-3"
                  />
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-2">Flexibilização Ambiental</div>
                  <v-row dense>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                      md="4"
                      v-for="opcao of opcoes.flexibilizacao_ambiental"
                      :key="opcao"
                    >
                      <v-checkbox
                        :id="`check-flexibilizacao-${slug(opcao)}`"
                        hide-details
                        dense
                        v-model="form.flexibilizacao_ambiental"
                        :label="opcao"
                        :value="opcao"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <!-- ===== PLANO EDUCACIONAL ESPECIALIZADO — PEI ===== -->
          <div v-show="secaoAtiva === 3">
            <div class="pa-4">
              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-2">
                    {{ isInfantil ? "Campo de Experiência" : "Disciplinas" }}
                    <v-chip class="ml-1" x-small :color="corDoBadge(totalDoRecorteCurricular)" dark>
                      {{ totalDoRecorteCurricular }} selecionada(s)
                    </v-chip>
                  </div>
                  <template v-if="isInfantil">
                    <v-row dense>
                      <v-col
                        class="py-0"
                        cols="12"
                        sm="6"
                        md="4"
                        v-for="opcao of opcoes.campos_de_experiencia"
                        :key="opcao"
                      >
                        <v-checkbox
                          :id="`check-campo-experiencia-${slug(opcao)}`"
                          hide-details
                          dense
                          v-model="form.campos_de_experiencia"
                          :label="opcao"
                          :value="opcao"
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <!-- Somente leitura: mostra o vínculo já cadastrado na gestão de aula
                       auxiliar, sem opção de marcar/desmarcar aqu-->
                  <template v-else>
                    <v-chip
                      v-for="disciplina of disciplinas"
                      :key="disciplina.id"
                      :id="`chip-disciplina-${disciplina.id}`"
                      color="primary"
                      outlined
                      class="mr-1 mb-1"
                    >
                      {{ disciplina.descricao }}
                    </v-chip>
                    <div v-if="!disciplinas.length" class="text-body-2 text--secondary font-italic">
                      Nenhuma disciplina vinculada a esta gestão
                    </div>
                  </template>
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-1">
                    Ponto de Partida — o que o aluno já sabe fazer
                    {{
                      isInfantil
                        ? "neste(s) campo(s) de experiência(s)?"
                        : "nesta(s) disciplina(s)?"
                    }}
                  </div>
                  <v-textarea
                    id="input-ponto-de-partida"
                    v-model="form.ponto_de_partida"
                    rows="5"
                    outlined
                    auto-grow
                    maxlength="1000"
                    counter
                  />
                  <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">
                    Metas Curriculares (MÊS/BIMESTRE) — defina 3 metas claras
                  </div>
                  <v-textarea
                    id="input-metas-curriculares"
                    v-model="form.metas_curriculares"
                    rows="5"
                    outlined
                    auto-grow
                    maxlength="1000"
                    counter
                  />
                  <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">
                    Adaptação de Acesso — como o conteúdo será entregue?
                  </div>
                  <v-textarea
                    id="input-adaptacao-de-acesso"
                    v-model="form.adaptacao_de_acesso"
                    rows="5"
                    outlined
                    auto-grow
                    maxlength="1000"
                    counter
                  />
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-2">
                    Avaliação
                    <v-chip class="ml-1" x-small :color="corDoBadge(form.avaliacao.length)" dark>
                      {{ form.avaliacao.length }} marcada(s)
                    </v-chip>
                  </div>
                  <v-row dense>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                      md="4"
                      v-for="opcao of opcoes.avaliacao"
                      :key="opcao"
                    >
                      <v-checkbox
                        :id="`check-avaliacao-${slug(opcao)}`"
                        hide-details
                        dense
                        v-model="form.avaliacao"
                        :label="opcao"
                        :value="opcao"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Avaliação de Progresso: uma seleção por vez -->
              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-1">
                    Avaliação de Progresso
                    <span class="text-caption text--secondary font-weight-regular">
                      (como saberemos que ele aprendeu? uma opção)
                    </span>
                  </div>
                  <e-opcao-unica-cards
                    v-model="form.avaliacao_de_progresso"
                    :opcoes="opcoes.avaliacao_de_progresso"
                    prefixo-id="radio-progresso"
                  />
                </v-card-text>
              </v-card>

              <v-card outlined class="pei-subcard mb-4">
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold mb-2">
                    Ações do Profissional de Apoio
                    <v-chip
                      class="ml-1"
                      x-small
                      :color="corDoBadge(form.acoes_profissional_apoio.length)"
                      dark
                    >
                      {{ form.acoes_profissional_apoio.length }} marcada(s)
                    </v-chip>
                  </div>
                  <v-row dense>
                    <v-col
                      class="py-0"
                      cols="12"
                      sm="6"
                      md="4"
                      v-for="opcao of opcoes.acoes_profissional_apoio"
                      :key="opcao"
                    >
                      <v-checkbox
                        :id="`check-acao-apoio-${slug(opcao)}`"
                        hide-details
                        dense
                        v-model="form.acoes_profissional_apoio"
                        :label="opcao"
                        :value="opcao"
                      />
                    </v-col>
                  </v-row>
                  <div class="text-subtitle-2 font-weight-bold mb-1 mt-3">
                    O que o mediador fará exatamente?
                  </div>
                  <v-textarea
                    id="input-acoes-apoio-texto"
                    v-model="form.acoes_profissional_apoio_texto"
                    rows="5"
                    outlined
                    auto-grow
                    class="mt-3"
                  />
                </v-card-text>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </template>
  </main-template>
</template>

<script>
export default {
  props: {
    gestaoId: {
      type: [String, Number],
      required: true,
    },
    bimestre: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      carregado: false,
      salvando: false,
      isInfantil: false,
      identificacao: {
        professores_regentes: [],
        deficiencias_do_cadastro: [],
      },
      // As listas de opções vêm do back já resolvidas para a etapa do aluno, então não
      // são duplicadas aqui: um único lugar define os textos que o PDF vai marcar.
      opcoes: {},
      disciplinas: [],
      peiExistente: false,
      form: this.formVazio(),
      grupoDeBarreiraAtivo: 0,
      secaoAtiva: 0,
      alturaMaximaQuadro: "calc(100vh - 280px)",
      secoes: [
        { valor: 0, titulo: "Identificação", icone: "fa fa-id-card" },
        { valor: 1, titulo: "Estudo de Caso", icone: "fa fa-search" },
        { valor: 2, titulo: "Plano de Suporte", icone: "fa fa-universal-access" },
        { valor: 3, titulo: "Plano Especializado", icone: "fa fa-graduation-cap" },
      ],
    };
  },
  watch: {
    /**
     * As 4 abas dividem o mesmo elemento com rolagem (v-show, não v-tabs-items/v-window);
     * trocar de aba não reseta sozinho a posição de rolagem do paSem isso, a aba nova
     * abre no mesmo scroll da aba anterior, cortando o topo do conteúdo dela.
     */
    secaoAtiva() {
      this.$nextTick(() => {
        if (this.$refs.conteudoPei) this.$refs.conteudoPei.scrollTop = 0;
      });
    },
  },
  computed: {
    bimestreDescricao() {
      const item = this.$constants.bimestres.find((b) => b.value === Number(this.bimestre));
      return item ? item.desc : `Bimestre ${this.bimestre}`;
    },
    dataFormatada() {
      const data = this.form.data || this.identificacao.data;
      if (!data) return "- - -";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    totalDeBarreiras() {
      return Object.values(this.form.mapeamento_barreiras).reduce(
        (total, marcadas) => total + (marcadas ? marcadas.length : 0),
        0
      );
    },
    totalDoRecorteCurricular() {
      return this.isInfantil
        ? this.form.campos_de_experiencia.length
        : this.form.disciplinas.length;
    },
  },
  async mounted() {
    await this.load();
    window.addEventListener("resize", this.atualizarAlturaQuadro);
    this.ocultarRodapeGlobal();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.atualizarAlturaQuadro);
    this.restaurarRodapeGlobal();
  },
  methods: {
    /**
     * O MainTemplate sempre renderiza um #footer-row (min-height: 90px) depois do
     * conteúdo da páginNesta tela o quadro já ocupa a altura da viewport certinho,
     * então esse rodapé sobra e cria um scroll externo por fora do quadro (que já rola
     * por dentroEle é do MainTemplate (compartilhado com outras páginas), então
     * escondo só enquanto esta página está montada, sem mexer no componente
     * compartilhado.
     */
    ocultarRodapeGlobal() {
      const footer = document.getElementById("footer-row");
      if (footer) footer.style.display = "none";
    },
    restaurarRodapeGlobal() {
      const footer = document.getElementById("footer-row");
      if (footer) footer.style.display = "";
    },
    /** Espera dois frames para medir depois do layout do cabeçalho assentar de vez. */
    atualizarAlturaQuadro() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const quadro = this.$refs.peiQuadro;
          if (!quadro) return;
          const margemInferior = 24;
          const topo = quadro.getBoundingClientRect().top;
          this.alturaMaximaQuadro = `${window.innerHeight - topo - margemInferior}px`;
        });
      });
    },
    formVazio() {
      return {
        bimestre: Number(this.bimestre),
        data: null,
        mapeamento_barreiras: {},
        mapeamento_barreiras_observacoes: {},
        potencialidades_interesses: [],
        interesse_especifico: null,
        descricao_demanda: null,
        demanda_como_aprende_melhor: null,
        demanda_barreiras_frequentes: null,
        demanda_estrategias_que_favoreceram: null,
        profissional_apoio_escolar: null,
        profissional_apoio_momentos: null,
        adaptacao_materiais: [],
        adaptacao_materiais_outra: null,
        flexibilizacao_ambiental: [],
        campos_de_experiencia: [],
        disciplinas: [],
        ponto_de_partida: null,
        metas_curriculares: null,
        adaptacao_de_acesso: null,
        avaliacao: [],
        avaliacao_de_progresso: null,
        acoes_profissional_apoio: [],
        acoes_profissional_apoio_texto: null,
      };
    },
    slug(texto) {
      return String(texto)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    },
    /** Cinza quando nada foi marcado, para o contador não fingir preenchimento. */
    corDoBadge(quantidade) {
      return quantidade > 0 ? "primary" : "grey";
    },
    barreirasDoGrupo(grupo) {
      return (this.form.mapeamento_barreiras[grupo] || []).length;
    },
    definirBarreiras(grupo, marcadas) {
      this.$set(this.form.mapeamento_barreiras, grupo, marcadas);
    },
    barreiraMarcada(grupo, item) {
      return (this.form.mapeamento_barreiras[grupo] || []).includes(item);
    },
    alternarBarreira(grupo, item, marcado) {
      const atual = this.form.mapeamento_barreiras[grupo] || [];
      const marcadas = marcado ? [...atual, item] : atual.filter((marcada) => marcada !== item);
      this.definirBarreiras(grupo, marcadas);
    },
    definirObservacao(grupo, texto) {
      this.$set(this.form.mapeamento_barreiras_observacoes, grupo, texto);
    },
    async load() {
      this.$loaderService.open("Carregando PEI...");
      try {
        const payload = await this.$services.peisService.formulario(this.gestaoId, this.bimestre);

        this.isInfantil = payload.is_infantil;
        this.identificacao = payload.identificacao;
        this.opcoes = payload.opcoes;
        this.disciplinas = payload.disciplinas || [];

        const vazio = this.formVazio();
        if (payload.pei) {
          this.peiExistente = true;
          this.form = Object.keys(vazio).reduce((acumulado, chave) => {
            const valor = payload.pei[chave];
            acumulado[chave] = valor === null || valor === undefined ? vazio[chave] : valor;
            return acumulado;
          }, {});
        } else {
          this.form = { ...vazio, data: this.identificacao.data };
        }
        // Disciplinas é somente leitura: reflete sempre o vínculo atual da gestão de
        // aula auxiliar, nunca uma escolha manual salva no PEI.
        if (!this.isInfantil) {
          this.form.disciplinas = this.disciplinas.map((disciplina) => disciplina.id);
        }

        this.carregado = true;
        this.$nextTick(() => this.atualizarAlturaQuadro());
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async salvar() {
      this.salvando = true;
      try {
        await this.$services.peisService.salvar(this.gestaoId, this.form);
        this.peiExistente = true;
        this.$toast.success("PEI salvo com sucesso");
      } catch (error) {
        this.$handleError(error);
      }
      this.salvando = false;
    },
    async baixar() {
      this.$loaderService.open("Gerando o PEI...");
      try {
        await this.$services.peisService.baixarPdf(this.gestaoId, this.bimestre);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped>
.pei-quadro {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 400px;
}

/*
  A classe utilitária flex-shrink-0 só neutraliza o encolhimento; o Vuetify aplica algum
  flex-grow interno ao v-tabs, e ele crescia até ~283px dentro do quadro, sobrando ~190px
  em branco DENTRO do próprio componente de abas (confirmado no inspetor: o elemento
  #tabs-secoes-pei media 283px, com só ~90px de conteúdo visível#id vence a
  especificidade do Vuetify e trava a barra na altura do próprio conteúdo.
*/
#tabs-secoes-pei {
  flex: 0 0 auto;
}

.pei-conteudo {
  flex: 1;
  overflow-y: auto;
  /* Sem isso, um filho flex não encolhe abaixo do tamanho do próprio conteúdo, e a
     rolagem interna nunca aparece — o quadro estoura em vez de rolar por dentr*/
  min-height: 0;
  /* Antes o quadro herdava fundo branco de um v-card em volta; sem ele o fundo cinza
     da página aparece atrás do conteúdo curto (aba 1) e no espaço vazio abaixo del*/
  background-color: #fff;
}

.barreiras-expansions ::v-deep .v-expansion-panel-header {
  text-transform: none;
  letter-spacing: normal;
}
</style>
